var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "site-detail-dashboard" }, [
    _c(
      "div",
      { staticClass: "dashboard-grid" },
      [
        _c(
          "DashboardCard",
          {
            staticClass: "status-card",
            attrs: { icon: "dashboard", title: "Site Durumu" },
          },
          [
            _c("a-switch", {
              attrs: {
                "checked-children": "Aktif",
                "un-checked-children": "Pasif",
                size: "large",
              },
              model: {
                value: _vm.localEnable,
                callback: function ($$v) {
                  _vm.localEnable = $$v
                },
                expression: "localEnable",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("DashboardCard", { attrs: { icon: "team", title: "Ajanlar" } }, [
          _c("div", { staticClass: "metric-value" }, [
            _vm._v(_vm._s(_vm.site.agentCount)),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "DashboardCard",
          { attrs: { icon: "global", title: "Domain Sayısı" } },
          [
            _c("div", { staticClass: "metric-value" }, [
              _vm._v(_vm._s(_vm.site.integratedOrigins.length)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "DashboardCard",
          { attrs: { icon: "eye", title: "Anlık Ziyaretçi", highlight: "" } },
          [
            _c("div", { staticClass: "metric-value realtime" }, [
              _vm._v(_vm._s(_vm.site.realtimeVisitorCount || 0)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "DashboardCard",
          { attrs: { icon: "api", title: "Entegrasyon" } },
          [
            _c("a-badge", {
              attrs: {
                status: _vm.site.isIntegrated ? "success" : "error",
                text: _vm.site.isIntegrated ? "Aktif" : "Pasif",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "DashboardCard",
          { attrs: { icon: "clock-circle", title: "Son Aktivite" } },
          [
            _c("div", { staticClass: "metric-text" }, [
              _vm._v(_vm._s(_vm.lastActivity())),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "DashboardCard",
          {
            staticClass: "suspend-card",
            class: { "is-suspended": _vm.site.suspend },
            attrs: { icon: "lock", title: "Askıya Alma" },
          },
          [
            _c("a-switch", {
              attrs: {
                "checked-children": "Aktif",
                "un-checked-children": "Pasif",
                size: "large",
              },
              model: {
                value: _vm.localSuspend,
                callback: function ($$v) {
                  _vm.localSuspend = $$v
                },
                expression: "localSuspend",
              },
            }),
            _vm._v(" "),
            _vm.site.suspendReason
              ? _c(
                  "div",
                  { staticClass: "suspend-reason" },
                  [
                    _c("a-tag", { attrs: { color: "red" } }, [
                      _vm._v(
                        _vm._s(_vm.getSuspendReasonText(_vm.site.suspendReason))
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("DashboardCard", { attrs: { icon: "solution", title: "Partner" } }, [
          _c("div", { staticClass: "metric-text" }, [
            _vm._v(
              _vm._s(_vm.$_.get(_vm.site, "partner.name") || "Partner Yok")
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "DashboardCard",
          {
            staticClass: "blink-card",
            attrs: { icon: "notification", title: "Blink" },
          },
          [
            _c("a-switch", {
              attrs: {
                "checked-children": "Aktif",
                "un-checked-children": "Pasif",
                size: "large",
              },
              model: {
                value: _vm.localBlink,
                callback: function ($$v) {
                  _vm.localBlink = $$v
                },
                expression: "localBlink",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "settings-section" }, [
      _c(
        "div",
        { staticClass: "section-header" },
        [
          _c("a-icon", { attrs: { type: "dollar" } }),
          _vm._v(" "),
          _c("h3", [_vm._v("Faturalandırma ve Ayarlar")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "settings-grid" },
        [
          _c("SettingCard", {
            attrs: {
              icon: "calendar",
              title: "Trial Süresi",
              value: _vm.trialDay + " Gün",
              "sub-value": _vm.getRemainingTrialDay() + " Gün Kaldı",
            },
            on: { edit: _vm.showTrialPrompt },
          }),
          _vm._v(" "),
          _c(
            "SettingCard",
            {
              staticClass: "payment-method-card",
              attrs: { icon: "credit-card", title: "Ödeme Yöntemi" },
            },
            [
              _c(
                "a-radio-group",
                {
                  attrs: { "button-style": "solid" },
                  model: {
                    value: _vm.localPaymentMethod,
                    callback: function ($$v) {
                      _vm.localPaymentMethod = $$v
                    },
                    expression: "localPaymentMethod",
                  },
                },
                [
                  _c("a-radio-button", { attrs: { value: "credit-card" } }, [
                    _vm._v("Kredi Kartı"),
                  ]),
                  _vm._v(" "),
                  _c("a-radio-button", { attrs: { value: "eft" } }, [
                    _vm._v("EFT/Havale"),
                  ]),
                  _vm._v(" "),
                  _c("a-radio-button", { attrs: { value: "btc" } }, [
                    _vm._v("BTC"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "percentage",
              title: "Genel İndirim",
              value: _vm.totalDiscount + "%",
            },
            on: { edit: _vm.showTotalDiscountPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "calendar",
              title: "Vade Gün Sayısı",
              value: _vm.invoiceDueDays || "Varsayılan (7)",
            },
            on: { edit: _vm.showInvoiceDueDaysPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "wallet",
              title: "Whatsapp Cüzdan",
              value: _vm.whatsappWallet + " TL",
            },
            on: { edit: _vm.showWhasappWalletPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "warning",
              title: "Whatsapp Alt Limit",
              value: _vm.maxLowBalance + " TL",
            },
            on: { edit: _vm.showWhasappLowLimitPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "mail",
              title: "Aylık Mail Limiti",
              value: "" + _vm.monthlyMailSendLimit,
            },
            on: { edit: _vm.showMonthlyMailSendLimitPrompt },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-section" }, [
      _c(
        "div",
        { staticClass: "section-header" },
        [
          _c("a-icon", { attrs: { type: "percentage" } }),
          _vm._v(" "),
          _c("h3", [_vm._v("Komisyon Ayarları")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "settings-grid" },
        [
          _c("SettingCard", {
            attrs: {
              icon: "whats-app",
              title: "Whatsapp Business Komisyon",
              value: _vm.gupshupCommission + "%",
            },
            on: { edit: _vm.showGupshupCommissionPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "message",
              title: "Whatsapp Komisyon",
              value: _vm.whatsappCommission + "%",
            },
            on: { edit: _vm.showWhatsappCommissionPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "robot",
              title: "OpenAI Komisyon",
              value: _vm.aiUsageCommission + "%",
            },
            on: { edit: _vm.showOpenAICommissionPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "phone",
              title: "AI Call Komisyon",
              value: _vm.aiCallCommission + "%",
            },
            on: { edit: _vm.showAiCallCommissionPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "calculator",
              title: "KDV Oranı",
              value: _vm.vatRate + "%",
            },
            on: { edit: _vm.showVatRatePrompt },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-section" }, [
      _c(
        "div",
        { staticClass: "section-header" },
        [
          _c("a-icon", { attrs: { type: "link" } }),
          _vm._v(" "),
          _c("h3", [_vm._v("Entegrasyon Bilgileri")]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "integration-info" }, [
        _c(
          "div",
          { staticClass: "info-item" },
          [
            _c("a-icon", { attrs: { type: "mobile" } }),
            _vm._v(" "),
            _c("span", { staticClass: "info-label" }, [_vm._v("Mobil")]),
            _vm._v(" "),
            _c("a-badge", {
              attrs: {
                status: _vm.site.mobileUserCount > 0 ? "success" : "error",
                text: _vm.site.mobileUserCount > 0 ? "Aktif" : "Pasif",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "info-item" },
          [
            _c("a-icon", { attrs: { type: "global" } }),
            _vm._v(" "),
            _c("span", { staticClass: "info-label" }, [_vm._v("Web Sitesi")]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "info-link",
                attrs: {
                  href:
                    (_vm.IS_DEV_ENVIRONMENT ? "http" : "https") +
                    "://" +
                    _vm.site.settings.website,
                  target: "_blank",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.site.settings.website) +
                    "\n                    "
                ),
                _c("a-icon", { attrs: { type: "link" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "info-item full-width" },
          [
            _c("a-icon", { attrs: { type: "deployment-unit" } }),
            _vm._v(" "),
            _c("span", { staticClass: "info-label" }, [
              _vm._v("Web Sitesi Origin'leri"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "origins-list" },
              _vm._l(_vm.site.integratedOrigins, function (dom, index) {
                return _c("div", { key: index, staticClass: "origin-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "origin-link",
                      attrs: {
                        href:
                          (_vm.IS_DEV_ENVIRONMENT ? "http" : "https") +
                          "://" +
                          dom,
                        target: "_blank",
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "link" } }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(dom) +
                          "\n                        "
                      ),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "danger-zone" },
      [
        _c(
          "div",
          { staticClass: "danger-header" },
          [
            _c("a-icon", { attrs: { type: "warning" } }),
            _vm._v(" "),
            _c("h3", [_vm._v("Tehlikeli Bölge")]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a-button",
          {
            attrs: { type: "danger", size: "large" },
            on: {
              click: function ($event) {
                return _vm.$emit("delete-site", _vm.site)
              },
            },
          },
          [
            _c("a-icon", { attrs: { type: "delete" } }),
            _vm._v("\n            Bu Site'yi Sil\n        "),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }